module.exports = __webpack_public_path__ + "img/hwdl10.52103744.jpg";